import React, { useState, useEffect } from 'react';
import { Tag, Space, ConfigProvider } from 'antd';
import { GetAllProcessos, DeleteProcesso } from '@services/Processo/Index.jsx';
import { CustomLoader } from '@components/UI/CustomLoader/Index.jsx';
import { EditOptionComp } from '@components/UI/EditOption/Index.jsx';
import { DeleteOptionComp } from '@components/UI/DeleteOption/Index.jsx';
import FilterView from '@components/UI/FilterView/Index.jsx';
import ptBR from 'antd/es/locale/pt_BR';
import { StyledTable } from '@styles/datatables/datatable-antd.js';
import TextBlock from '@components/UI/TextBlock/Index..jsx';
import Select from 'react-select';
import { flgStatusOptions } from '@enums/FlgStatus/Index';
import customStylesSelect from '@styles/react-select';

const GridProcesso = ({ state, setData, openModal, setSelectedRow, onDelete }) => {
  const [filters, setFilters] = useState({
    codigo: '',
    nomeProcesso: '',
    flgStatus: '',
  });
  const filterLabels = {
    codigo: 'CÓDIGO',
    nomeProcesso: 'PROCESSO',
    flgStatus: 'STATUS',
  };
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const fetchData = async (currentPage, currentRowsPerPage, filters = {}) => {
    setLoading(true);
    try {
      const response = await GetAllProcessos(currentPage, currentRowsPerPage, filters);
      setData(response.items, response.totalItems);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(page, rowsPerPage, filters);
  }, [page, rowsPerPage, filters]);

  const handlePageChange = (newPage, newRowsPerPage) => {
    setPage(newPage);
    setRowsPerPage(newRowsPerPage);
  };

  const columns = [
    {
      title: 'CÓDIGO',
      dataIndex: 'codigo',
      key: 'codigo',
      sorter: (a, b) => a.codigo - b.codigo,
      width: '15%',
    },
    {
      title: 'PROCESSO',
      dataIndex: 'nomeProcesso',
      key: 'nomeProcesso',
      sorter: (a, b) => a.nomeProcesso.localeCompare(b.nomeProcesso),
      width: '60%',
      render: (text, record) => (
        <TextBlock>
          {text}
        </TextBlock>
      ),
    },
    {
      title: 'STATUS',
      dataIndex: 'flgStatus',
      key: 'flgStatus',
      sorter: (a, b) => a.flgStatus - b.flgStatus, // Ordenação
      render: (flgStatus) => (
        <Tag color={(flgStatus) === true ? 'green' : 'red'}>
          {(flgStatus) === true ? 'ATIVO' : 'INATIVO'}
        </Tag>
      ),
      width: '15%',
    },
    {
      title: 'AÇÕES',
      key: 'actions',
      render: (text, row) => (
        <Space size="middle">
          <EditOptionComp
            row={row}
            setSelectedRow={setSelectedRow}
            openModal={openModal}
          />
          <DeleteOptionComp
            row={row}
            deleteFunction={DeleteProcesso}
            onDelete={onDelete}
            itemNameKey={"nomeProcesso"}
          />
        </Space>
      ),
      width: '10%',
    },
  ];

  const customFieldComponents = {
    flgStatus: ({ value, onChange }) => (
      <Select
        value={flgStatusOptions.find(opt => opt.value === value)}
        onChange={option => onChange(option?.value ?? "")}
        placeholder={"Selecione um status"}
        options={flgStatusOptions}
        isClearable
        isSearchable={false}
        styles={customStylesSelect}
      />
    )
  };

  return (
    <div className='px-4'>
      <FilterView
        filters={filters}
        setFilters={setFilters}
        filterLabels={filterLabels}
        customFieldComponents={customFieldComponents}
      />

      <div className='mt-3 mb-3'>
        <h1> Lista de Processos Registrados </h1>
      </div>

      <ConfigProvider locale={ptBR}>
        <StyledTable
          rowKey={"id"}
          columns={columns}
          dataSource={state.data}
          loading={{
            spinning: loading,
            indicator: <CustomLoader />,
          }}
          pagination={{
            current: page,
            pageSize: rowsPerPage,
            total: state.totalRows,
            onChange: handlePageChange,
            showSizeChanger: true,
            onShowSizeChange: handlePageChange,
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`, // Exibe o total de registros
          }}
          scroll={{ y: '20rem', x: 'max-content' }}
          locale={{ emptyText: <h2 className='m-3'>Nenhum registro disponível para exibição.</h2> }}
        />
      </ConfigProvider>
    </div>
  );
};

export default GridProcesso;